/**
 * Authentication API - Login and registration endpoints
 */
import { apiClient } from '../../../core';
import { storage } from '../../../core/utils/storage';

export const authApi = {
  login: async (username, password) => {
    const response = await apiClient.post('/login', { username, password });

    // Store authentication data
    if (response.data.access_token) {
      storage.setAuth(
        response.data.access_token,
        response.data.username,
        response.data.permissions
      );
    }

    return response;
  },

  register: async (username, password) => {
    const response = await apiClient.post('/register', { username, password });
    return response;
  },
};
